export const messages = {
  en: {
    communityMini: {
      title: 'Community Mini Program',
      name: 'Name',
      communityName: 'Community Name',
      appSecret: 'App Secret',
      description: 'Description',
      operation: 'Operation',
      add: 'Add',
      edit: 'Edit',
      cancel: 'Cancel',
      save: 'Save',
      requiredName: 'Required, please fill in the name',
      requiredAppId: 'Required, please fill in APPID',
      requiredSecret: 'Required, please fill in App Secret',
      optionalDescription: 'Optional, please fill in description'
    }
  },
  zh: {
    communityMini: {
      title: '园区小程序',
      name: '名称',
      communityName: '园区名称',
      appSecret: '应用密钥',
      description: '描述',
      operation: '操作',
      add: '添加',
      edit: '修改',
      cancel: '取消',
      save: '保存',
      requiredName: '必填，请填写名称',
      requiredAppId: '必填，请填写APPID',
      requiredSecret: '必填，请填写应用密钥',
      optionalDescription: '选填，请填写描述信息'
    }
  }
}